<div ngbDropdown placement="bottom-right">
  <button type="button" class="btn btn-dark btn-sm" [title]="loginService.userInfo?.name || ('anonymous' | translate)"
          ngbDropdownToggle>
    <span class="username">{{loginService.userInfo?.name}}</span>
    <span class="fas fa-user-circle fa-2x fa-fw" aria-hidden="true"></span>
    <span class="sr-only" translate>User menu</span>
  </button>
  <div class="dropdown-menu" ngbDropdownMenu>
    <ng-content></ng-content>
    <button
      ngbDropdownItem
      *ngFor="let language of languages"
      (click)="selectLanguage(language)">
      {{languageName(language)}}
      <span
        [ngClass]="{'fas fa-fw fa-check ml-1': language === selectedLanguage}"></span>
    </button>
    <div class="dropdown-divider"></div>

    <a class="dropdown-item" href="javascript:" (click)="info()">
      {{"version" | translate}}
    </a>

    <div class="dropdown-divider"></div>

    <a class="dropdown-item" href="javascript:" (click)="loginLogout()" [class.disabled]="isLoginDisabled">
      {{loginService.userLoggedIn ? ('Logout' | translate) : ('Login' | translate)}}
    </a>
  </div>
</div>
